export default {
  backgroundColor: "#cee4e5",
  lineHeight: "16px",
};

